import { Link } from "react-router-dom";

export default function AboutPage() {
  return (
    <>
      <section className="hero wrap">
        <div className="hero-meta">
          <span className="pin">About</span>
        </div>
        <h1>
          OpenTelemetry is open.
          <br /> Collector management should be too.
        </h1>
        <div className="about-lede-grid">
          <p className="lede">
            OpenTelemetry Collector has become the standard way to receive, process, and export
            telemetry. But the operational experience around collector fleets is still too manual.
          </p>
          <p className="lede">
            Teams end up with scattered YAML, unclear rollout history, and limited visibility into
            what is actually running. We are building a hosted OpAMP control plane so teams can
            adopt collector management incrementally — monitor first, manage when ready, and keep
            telemetry flowing to the systems they already trust.
          </p>
        </div>
      </section>

      <section className="section section-tight">
        <div className="wrap">
          <div className="about-manifesto-grid">
            <div>
              <span className="eyebrow">Manifesto</span>
            </div>
            <blockquote style={{ fontSize: "1.5rem", lineHeight: 1.5, margin: 0 }}>
              Telemetry should be portable. Configuration should be auditable. Adoption should be
              incremental. We are not trying to become another required destination — we are trying
              to make the layer that already exists feel operable.
            </blockquote>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <div className="section-head">
            <span className="eyebrow">What we believe</span>
          </div>
          <div className="about-beliefs-grid">
            {[
              {
                title: "Open standards over proprietary agents",
                desc: "Built on OpAMP and OpenTelemetry — not another bespoke agent.",
              },
              {
                title: "Control without lock-in",
                desc: "Your telemetry goes wherever you point it. We manage the fleet, not the data.",
              },
              {
                title: "Free fleet management",
                desc: "Start with visibility and manual deployment. Pay when governance becomes real.",
              },
              {
                title: "Git-ready workflows",
                desc: "The current MVP stores uploaded YAML versions; Git-backed sync is planned.",
              },
              {
                title: "Transparent pricing",
                desc: "Pay for management, not for data volume. No per-GB surprises.",
              },
              {
                title: "Safe rollouts over magical automation",
                desc: "Rollouts are explicit and immediate today; progressive rollout controls are planned.",
              },
            ].map((v) => (
              <div key={v.title} className="about-belief-card">
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <div className="cta-block">
            <h2>Want to follow along?</h2>
            <p className="lede">
              We share progress in the open. Star the repo, join the community, or just keep an eye
              on the changelog.
            </p>
            <div className="hero-actions">
              <Link to="/signup" className="btn btn-primary btn-lg">
                Request access →
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
